import classes from './Project.module.css';
import Card from '../layout/Card';
import ProjectItem from './ProjectItem';
import rest_image from '../img/rest.jpeg';
import react from '../img/react.png';
import js from '../img/js.png';
import html from'../img/html.png';
import css from '../img/css.png';
import bootstrap from '../img/bootstrap.png';
import library from '../img/library.jpeg';
import buttons from '../img/buttons.jpeg';
import crypto from '../img/crypto.jpeg';
import bank from '../img/bank.jpeg';
import profile from '../img/profile.png';
import cafe from '../img/cafe.jpeg';
const DUMMY_projects_Data = [
    {
      id: 'm1',
      name: 'Books store',
      description: 'built with react',
      price: 22.99,
      image:library,
      logo:[html,css,react],
      git:'https://github.com/alimelllo/books-store',
      detail: [ ' built with react & javascript',
        '  using create react app',
    'including add to cart items to buy ',
  ' fully responsive layout',
  'declaretive and reusable code'
    ],link:"https://books-store-5ca0f.web.app/"
    },
    {
      id: 'm2',
      name: 'Game',
      description: 'Tap game',
      price: 16.5,
      image:buttons,
      logo:[js,css,html],
      git:'https://github.com/alimelllo/remember-game-',
      detail: [ ' built with vanilla javascirot',
      '  simple tap game using css styles',
' fully responsive layout',
'declaretive and reusable code'
  ],link:"https://alisgame.netlify.app"
    }, {
      id: 'm2.5',
      name: 'Cafe menu ',
      description: 'shop decription',
      price: 12.99,
      image:cafe,
      logo:[css,html,react],
      git:'https://github.com/alimelllo/',
      detail: [ ' built with create react app',
      '  simple cafe menu ',
  ' realworld project',
' fully responsive layout',
'declaretive and reusable code'
  ],link:"https://menu-88fb2.web.app/"
    },
    {
      id: 'm3',
      name: 'Crypto Currency',
      description: 'shop decription',
      price: 12.99,
      image:crypto,
      logo:[css,html,bootstrap],
      git:'https://github.com/alimelllo/sarafi-template',
      detail: [ ' built with bootstrap & html',
      '  simple crypto web template',
  ' realworld project',
' fully responsive layout',
'declaretive and reusable code'
  ],link:"https://epic-minsky-947f9c.netlify.app"
    },
    {
      id: 'm4',
      name: 'Shop Template',
      description: 'rrrr',
      price: 18.99,
      image:rest_image,
      logo:[bootstrap,css,html],
      git:'https://github.com/alimelllo/shop-template',
      detail: [ ' built with bootstrap & html',
      '  including neomorphic design',
' fully responsive layout',
'declaretive and reusable code'
  ],link:"https://zealous-goldwasser-811e76.netlify.app/"
    },
    {
      id: 'm5',
      name: 'Bank Template',
      description: 'rrrr',
      price: 18.99,
      image:bank,
      logo:[js,css,html],
      git:'https://github.com/alimelllo',
      detail: [ ' built with css & javascript',
      '  including advanced dom events',
' no responsive layout',
'declaretive and reusable code'
  ],link:"https://quirky-sinoussi-6fcbfb.netlify.app"
    },
    {
      id: 'm6',
      name: 'Portfolio',
      description: 'rrrr',
      price: 18.99,
      image:profile,
      logo:[react,css,html],
      git:'https://github.com/alimelllo/portfolio',
      detail: [ ' built with css & javascript',
      '  including advanced dom events',
' no responsive layout',
'declaretive and reusable code'
  ],link:"https://portfolio-c522d.web.app/home"
    },
]

  
  const Project = (props) => {
  
  
  
  
  
    const projectsList = DUMMY_projects_Data.map((meal) => (
   
      <ProjectItem
        key={meal.id}
        id={meal.id}
        name={meal.name}
        description={meal.description}
        image={meal.image}
        onClick={ () => {
         props.onShowCart(meal)
        }}
    logoarr={meal.logo}
       
      />
    ));
  



    return (
      <section className={classes.meals}>
        
          {projectsList}
        
      </section>
    );
  };
  
  export default Project;